"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getLogos = getLogos;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGO_LOAD = "ms/companyLogos/logo_load";
var LOGO_LOAD_SUCCESS = "ms/companyLogos/logo_load_success";
var LOGO_LOAD_FAIL = "ms/companyLogos/logo_load_fail";

var initialState = {
  megascans_footer_logos: [],
  megascans_wall_logos: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOGO_LOAD:
      return (0, _extends3.default)({}, state, {
        logoLoaded: false,
        error: null
      });

    case LOGO_LOAD_SUCCESS:
      console.log(action.result);

      var wallLogos = action.result.filter(function (item) {
        return item.name === "megascans_wall_logos";
      })[0];
      var footerLogs = action.result.filter(function (item) {
        return item.name === "megascans_footer_logos";
      })[0];
      return (0, _extends3.default)({}, state, {
        megascans_footer_logos: footerLogs ? footerLogs.value : [],
        megascans_wall_logos: wallLogos ? wallLogos.value : [],
        logoLoaded: true,
        error: null
      });
    case LOGO_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        megascans_footer_logos: [],
        megascans_wall_logos: [],
        logoLoaded: true,
        error: action.error
      });
    default:
      return state;
  }
}

function getLogos() {
  return function (dispatch, getState) {
    var _getState = getState(),
        megascans_footer_logos = _getState.companyLogos.megascans_footer_logos;

    if (megascans_footer_logos && megascans_footer_logos.length > 0) {
      return;
    }
    return dispatch({
      types: [LOGO_LOAD, LOGO_LOAD_SUCCESS, LOGO_LOAD_FAIL],
      promise: function promise(client) {
        return client.post("/v1/staticContent/getStaticContent");
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/companyLogos.js
// module id = 1155
// module chunks = 0